import CoveragePackageModalLink from '../CoveragePackageModalLink';
import Currency from '../../../../shared_components/Currency/Currency';
import { GridItem, Box, NumberField } from '@flos/react-ui';
import { useHippoText } from '../../../../hooks/useHippoText';
import { useState } from 'react';
import { useUpdateCoveragePackageInformation } from '../../../../recoil/hooks/useUpdateCoveragePackageInformation';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { getOnsaCurrentProductSelector } from '../../../../recoil/selectors/getOnsaCurrentProductSelector';
import { useUpdateCoverableInformation } from '../../../../recoil/hooks/useUpdateCoverableInformation';
import { allCoverablesOnsaAtom } from '../../../../recoil/atoms/allCoverablesOnsaAtom';
import { getOnsaCoverable } from '../../../../utils/coverablesUtil';
import type {
    AdultAccidentOnsaDTO,
    ChildAccidentOnsaDTO,
    YoungAccidentOnsaDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/accident';
import { refreshCoveragePackagePricesAtom } from '../../../../recoil/atoms/refreshCoveragePackagePricesAtom';
const CoveragePackageAccidentInputs = ({
    isLoading,
    setIsLoading
}: {
    isLoading: boolean;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const refreshPrices = useSetRecoilState(refreshCoveragePackagePricesAtom);
    const { updateCoveragePackageInformation } = useUpdateCoveragePackageInformation<
        AdultAccidentOnsaDTO | YoungAccidentOnsaDTO | ChildAccidentOnsaDTO
    >();
    const currentProduct = useRecoilValue(getOnsaCurrentProductSelector);
    const { flavourName = '', fixedId = '' } = currentProduct ?? {};
    const coverables = useRecoilValue(allCoverablesOnsaAtom);
    const coverable = getOnsaCoverable(coverables, flavourName, fixedId) as
        | AdultAccidentOnsaDTO
        | YoungAccidentOnsaDTO
        | ChildAccidentOnsaDTO;
    const [insuranceSum, setInsuranceSum] = useState(coverable.insuranceSum?.toString());
    const lowerLimit = 500000;
    const upperLimit = flavourName === 'Ulykkesforsikring til unge' ? 3000000 : 6000000;
    const insuranceSumAsNumber = Number(insuranceSum?.split(' ')[0].split('.').join(''));
    const isTooLow = insuranceSumAsNumber < lowerLimit;
    const isTooHigh = insuranceSumAsNumber > upperLimit;
    const isThousandDivisble = insuranceSumAsNumber % 1000 === 0;
    const isValid = !isTooLow && !isTooHigh && isThousandDivisble;

    const onBlur = (): void => {
        const sum = insuranceSumAsNumber;
        if (isValid) {
            setIsLoading(true);
            updateCoverableInformation({ insuranceSum: sum });
            void updateCoveragePackageInformation({ insuranceSum: sum }).then(() => {
                setIsLoading(false);
                refreshPrices({});
            });
        }
    };
    return (
        <GridItem span={7}>
            <Box>
                <div className="u-flex-box u-flex-box--space-between">
                    <h4>{getHippoText('DSS-COVERAGE-PACKAGE-PAGE-SUM-INPUT-HEADER')}</h4>
                    <CoveragePackageModalLink
                        modalName={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-INPUT-INFO')}
                        title={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-SUM-INPUT-HEADER')}
                        description={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-INSURANCE-SUM-TEXT')}
                    />
                </div>
                <div className="u-spacing-stack-none">
                    <NumberField
                        wrapperClassName="u-spacing-stack-bottom-2"
                        label={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-SUM-INPUT-FIELD-LABEL')}
                        value={insuranceSum}
                        suffix=" kr."
                        withFormatting
                        disabled={isLoading}
                        onChange={(event) => {
                            setInsuranceSum(event.target.value);
                        }}
                        onBlur={onBlur}
                        isValid={isValid}
                        errorText=""
                        required
                    />
                    <p
                        className={
                            'paragraph--small u-spacing-stack-none u-color-secondary-4-medium'
                        }
                    >
                        Du kan vælge et beløb mellem{' '}
                        {<Currency decimals={0} currencyString={''} price={lowerLimit} />} -{' '}
                        {<Currency decimals={0} currencyString={' '} price={upperLimit} />} kr.
                    </p>
                    {(isTooHigh || isTooLow) && (
                        <p className="paragraph--small u-spacing-stack-none u-color-supplement-error-base">
                            {getHippoText(
                                isTooHigh
                                    ? 'DSS-ACC-CHILD-CONDITIONS-TOO-HIGH'
                                    : 'DSS-ACC-CHILD-CONDITIONS-TOO-LOW'
                            )}
                        </p>
                    )}
                    {!isThousandDivisble && (
                        <p className="paragraph--small u-spacing-stack-none u-color-supplement-error-base">
                            {getHippoText('DSS-ACC-CHILD-CONDITIONS')}
                        </p>
                    )}
                </div>
            </Box>
        </GridItem>
    );
};
export default CoveragePackageAccidentInputs;
